import { Link } from "react-router-dom";
import PortalNav from "../components/PortalNav";
import ProgressRing from "../components/ProgressRing";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";

const TODAY = [
  { time: "6:30", title: "Morning ritual & breathwork", loc: "The Solarium" },
  { time: "8:00", title: "Nourishment — Chef's plate", loc: "The Dining Room" },
  { time: "10:00", title: "Identity coaching, 1:1", loc: "The Study" },
  { time: "13:30", title: "Movement & embodiment", loc: "The Movement Room" },
  { time: "17:00", title: "Herbal regimen & rest", loc: "Your Suite" },
];

export default function Dashboard() {
  const { user, logout } = useAuth();
  const name = user?.name || "Guest";
  const day = user?.day ?? 7;

  return (
    <div className="portal-body" data-testid="dashboard-page">
      {/* Header */}
      <header style={{ background: "var(--charcoal)", color: "var(--ivory)", padding: "28px 24px 40px" }}>
        <div className="container-x" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <span className="brand-mark" style={{ fontSize: "1.4rem" }}>SAVIAR</span>
          <button
            onClick={logout}
            style={{ background: "transparent", border: "none", color: "var(--gold-light)", display: "flex", alignItems: "center", gap: 6, fontSize: ".7rem", letterSpacing: ".2em", textTransform: "uppercase", cursor: "pointer" }}
            data-testid="logout-btn"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
        <div className="container-x">
          <p className="eyebrow eyebrow-light">The Residency</p>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 300, fontSize: "clamp(1.9rem, 4vw, 2.6rem)", margin: "12px 0 6px" }}>
            Welcome back, {name}.
          </h1>
          <p style={{ color: "rgba(250,246,238,.55)", fontSize: ".95rem" }}>Day {day} of 21. Softness is the practice.</p>
        </div>
      </header>

      <main className="container-x" style={{ padding: "40px 24px 24px", display: "grid", gap: 24 }}>
        {/* Progress + Today */}
        <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 32, alignItems: "center" }} className="portal-card" data-testid="progress-card">
          <ProgressRing day={day} total={21} />
          <div>
            <p className="eyebrow" style={{ marginBottom: 12 }}>Your Reset</p>
            <h3 style={{ margin: "0 0 8px" }}>You're one-third through your softening.</h3>
            <p className="body-sm">Week 1 was the arrival. This week — Deep Reset — is where your nervous system starts to trust the pause. Keep showing up softly.</p>
          </div>
        </div>

        {/* Today's schedule */}
        <div className="portal-card" data-testid="today-schedule">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 20 }}>
            <div>
              <p className="eyebrow">Today</p>
              <h3 style={{ margin: "6px 0 0" }}>Your daily rhythm</h3>
            </div>
            <Link to="/portal/schedule" className="btn-ghost">Full Schedule</Link>
          </div>
          <div>
            {TODAY.map((b, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "60px 1fr auto", gap: 20, padding: "16px 0", borderBottom: i === TODAY.length - 1 ? "none" : "1px solid rgba(184,150,90,.15)", alignItems: "baseline" }}>
                <span style={{ fontFamily: "var(--serif)", fontSize: "1.1rem", color: "var(--gold)" }}>{b.time}</span>
                <span style={{ fontFamily: "var(--serif)", fontSize: "1.1rem", color: "var(--charcoal)" }}>{b.title}</span>
                <span style={{ fontSize: ".72rem", letterSpacing: ".2em", textTransform: "uppercase", color: "var(--warm-gray)" }}>{b.loc}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Quick links */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 16 }} data-testid="quick-links">
          {[
            { to: "/portal/log", label: "Wellness Log", sub: "Check in for today" },
            { to: "/portal/journal", label: "Journal", sub: "Write freely" },
            { to: "/portal/program", label: "My Program", sub: "Intake & regimen" },
            { to: "/portal/alumni", label: "Alumni", sub: "Unlocks Day 21" },
          ].map((q) => (
            <Link key={q.to} to={q.to} className="portal-card" style={{ textDecoration: "none", padding: 24, transition: "background .2s" }} data-testid={`quick-${q.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="eyebrow" style={{ marginBottom: 8 }}>{q.label}</p>
              <p className="body-sm" style={{ margin: 0 }}>{q.sub}</p>
            </Link>
          ))}
        </div>
      </main>
      <PortalNav />
    </div>
  );
}
